import * as actionTypes from './actions'
import _ from 'lodash'

const initialState = {
  unreadChatrooms: []
}

export default (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.INIT_NOTIFICATIONS:
      return initNotifications(state, action)
    case actionTypes.ADD_NOTIFICATION:
      return addNotification(state, action)
    case actionTypes.REMOVE_NOTIFICATION:
      return removeNotification(state, action)
    default:
      return state
  }
}

const removeNotification = (state, action) => {
  const { payload } = action
  switch (payload.type) {
    case "unread_chatroom":
      const unreadChatrooms = state.unreadChatrooms.filter(e => e !== payload.chatroom_id)
      return {
        ...state,
        unreadChatrooms,
      }
    default:
      return state
  }
}

const addNotification = (state, action) => {
  const { payload } = action
  switch (payload.type) {
    case "unread_chatroom":
      const unreadChatrooms = _.uniq([...state.unreadChatrooms, payload.chatroom_id])
      return {
        ...state,
        unreadChatrooms,
      }
    default:
      return state
  }
}

const initNotifications = (state, action) => {
  const { notifications } = action.payload
  return {
    ...state,
    unreadChatrooms: notifications.unread_chatrooms,
  }
}



// WEBPACK FOOTER //
// ./src/modules/notificationReducer.js